// FeatureFlag — Primitive 5.
// Every flagged behavior in the platform is declared in the central registry
// (packages/contracts/src/feature-flags/registry.ts). Schema columns exist on
// day 1; flag flips control UI / resolver paths only.
// See DOCS/architecture/primitives/feature-flag.md.
import { z } from 'zod';
// ---------------------------------------------------------------------------
// Scope + value shape
// ---------------------------------------------------------------------------
export const FeatureFlagScope = z.enum(['global', 'group', 'user']);
/** A flag value is a JSON literal: boolean (most common), string, or number. */
export const FeatureFlagValue = z.union([z.boolean(), z.string(), z.number()]);
// ---------------------------------------------------------------------------
// FeatureFlagDescriptor — one entry in the central registry.
// ---------------------------------------------------------------------------
export const FeatureFlagDescriptor = z.object({
    /** e.g. `group.hierarchy`, `forum.reputation`. Unique. */
    key: z.string().min(1),
    /** Default value when no override is configured. */
    defaultValue: FeatureFlagValue,
    /** Who/what the flag applies to. */
    scope: FeatureFlagScope,
    /** Owning module (`identity/groups`, `community/forum`, …). */
    ownerModule: z.string().min(1),
    /** Human-readable explanation surfaced in the admin flag-management UI. */
    description: z.string(),
    /** Optional rollout strategy — drives the admin UI's flag controls. */
    rolloutPlan: z
        .object({
        percent: z.boolean().optional(),
        allowlist: z.array(FeatureFlagScope).optional(),
    })
        .optional(),
    schemaVersion: z.literal(1),
});
//# sourceMappingURL=feature-flag.js.map